import actionTypes from 'SRC/modules/redux/actionTypes'

export const setPromoVehicleParts = parts => ({
  type: actionTypes.SET_PROMO_VEHICLE_PARTS,
  payload: parts
})
